import { ATTRIBUTE_APPLICATION_ID } from './constant';
import veritoneApi from './veritoneApi';
import { get } from 'lodash';

export function getAppSettingApi(urlApi) {
  return veritoneApi(urlApi.baseUrl)
    .get(urlApi.appSetting)
    .then(responve => responve)
    .catch(error => error);
}

export function updateAppSettingApi(urlApi, appSetting) {
  return veritoneApi(urlApi.baseUrl)
    .put(urlApi.appSetting, appSetting)
    .then(response => response)
    .catch(error => ({
      error: true,
      ...error
    }));
}

function genFeatureFlagQuery(organizationId) {
  return `query {
    applicationConfig(
      appId: "${ATTRIBUTE_APPLICATION_ID}"
      orgId: ${organizationId}
    ) {
      records {
        configKey
        configType
        description
        configLevel
        configType
        value
      }
    }
  }
  `;
}

export function getFeatureFlagApi(urlApi, organizationId) {
  return veritoneApi(urlApi.graphql)
    .post('', { query: genFeatureFlagQuery(organizationId) })
    .then(response => {
      return get(response, 'data.data.applicationConfig.records', null);
    })
    .catch(error => ({
      error: true,
      ...error
    }));
}

export function getCurrentEmailIngestionSetting(urlApi, orgId, token) {
  return veritoneApi(urlApi.baseUrl, token)
    .get(`/playout/ingestion_settings?org_id=${orgId}`)
    .then(response => response)
    .catch(error => error);
}
